import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import { formatSubscriberCount, formatAbbreviatedSubscriberCount } from '../../../commons/utils/formatCount';
import tricolorBar from './tricolorBar.svg';
import * as styles from './styles';

function SubscriberCounter({ totalSubscribers, loading }) {
    if (loading) {
        return (
            <Box sx={styles.pill}>
                <Box sx={styles.barWrapper}>
                    <Skeleton variant="rounded" animation="pulse" sx={{ ...styles.bar, ...styles.skeletonTone }} />
                    <Skeleton variant="rounded" animation="pulse" sx={{ ...styles.badge, ...styles.skeletonTone }} />
                </Box>
                <Skeleton variant="text" animation="pulse" width={180} height={18} sx={styles.skeletonTone} />
            </Box>
        );
    }

    const subscriberCount = formatSubscriberCount(totalSubscribers);
    const abbreviatedCount = formatAbbreviatedSubscriberCount(totalSubscribers);

    if (!subscriberCount) return null;

    return (
        <Box sx={styles.pill}>
            <Box sx={styles.barWrapper}>
                <Box component="img" src={tricolorBar} alt="" aria-hidden="true" sx={styles.bar} />
                {abbreviatedCount && (
                    <Box sx={styles.badge}>{abbreviatedCount}</Box>
                )}
            </Box>
            <Typography sx={styles.label}>
                Trusted by <Box component="span" sx={styles.count}>{subscriberCount}</Box> Calendar Subscribers
            </Typography>
        </Box>
    );
}

export default SubscriberCounter;
